import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";

const QuickTaleSavedModal = ({
  open,
  onReturn,
  onCreate,
}) => {
  return (
    <Dialog
      open={open}
      aria-labelledby="quicktale-saved-dialog-title"
      aria-describedby="quicktale-saved-dialog-description"
    >
      <DialogTitle id="quicktale-saved-dialog-title">
        QuickTale Saved!
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="quicktale-saved-dialog-description">
          Would you like to create another QuickTale or go back to QuickTales in Organization?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onReturn} color="primary">
          Return
        </Button>
        <Button onClick={onCreate} color="primary" autoFocus>
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QuickTaleSavedModal;
